export const NOTI_STATUS = {
  READ: 'READ',
  UNREAD: 'UNREAD',
};
